export default "__VITE_ASSET__72b3a352__"